module.exports = __webpack_public_path__ + "img/33715685000101.39d8c2b8.png";